import { render, staticRenderFns } from "./BankTransfersIcon.vue?vue&type=template&id=5710e9f4"
import script from "./BankTransfersIcon.vue?vue&type=script&lang=ts"
export * from "./BankTransfersIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports